/**
 * Returns the primary numeric id for a driver. Drivers on the Golia side
 * carry both `id` and `id_golia` — different code paths populate one or
 * the other, so consumers need to prefer `id` and fall back to `id_golia`.
 */
export default function driverPrimaryId(driver) {
    if (!driver) {
        return null
    }
    return driver.id ?? driver.id_golia ?? null
}
